import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { registerOfflineShell } from './app/offline';
import './styles/app.css';
createRoot(document.getElementById('root')!).render(<App />);
// After first paint and load, so the shell never competes with startup.
window.addEventListener('load', () => registerOfflineShell(), { once: true });
